<template>
    <div>
        <h2 style="color: #fff">公式配置</h2>
        <button @click="func1">点我</button><br />
        <span style="color: #fff"> {{ ttj }} </span><br />
        <button @click="func2">清除</button><br />
        <div style="width: 500px; height: 500px; background-color: aquamarine">
            <el-button style="">niggai1</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "calfuncheckView",
        data() {
            return {
                ttj: "",

                tableData: [
                    {
                        date: "2016-05-02",
                        name: "王小虎",
                        address: "上海市普陀区金沙江路 1518 弄",
                        tag: "家",
                    },
                    {
                        date: "2016-05-04",
                        name: "王小虎",
                        address: "上海市普陀区金沙江路 1517 弄",
                        tag: "公司",
                    },
                    {
                        date: "2016-05-01",
                        name: "王小虎",
                        address: "上海市普陀区金沙江路 1519 弄",
                        tag: "家",
                    },
                    {
                        date: "2016-05-03",
                        name: "王小虎",
                        address: "上海市普陀区金沙江路 1516 弄",
                        tag: "公司",
                    },
                ],
            };
        },
        methods: {
            func1() {
                this.ttj = "123";
            },
            func2() {
                this.ttj = "";
            },

            filterTag(value, row) {
                return row.tag === value;
            },
        },
    };
</script>

<style lang="scss" scoped></style>
